<template>
  <div class="delete-user">
    <h1>{{ $t('users.delete_confirm') }}</h1>
    <div class="button-container">
      <button class="button-submit delete-btn" type="submit" @click="deleteUser">
        {{ $t('users.delete') }}
      </button>

      <router-link class="user-add" to="/users">
        <button class="button-submit delete-btn" type="submit">
          {{ $t('users.cancel') }}
        </button>
      </router-link>
    </div>
    <div class="error">{{ this.error_message }}</div>
    <div class="success">{{ this.success_message }}</div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { api } from '@/api';
import { errorHandler } from '@/mixins';

export default {
  name: 'User',
  components: {},
  mixins: [errorHandler],
  computed: {
    ...mapState(['auth', 'user'])
  },
  watch: {},
  data() {
    return {
      user_id: this.$route.params.id,
      error_message: '',
      success_message: ''
    };
  },

  methods: {
    deleteUser() {
      console.log('deleteUser', this.user_id);
      this.error_message = '';
      this.success_message = '';
      api
        .delete(`/users/${this.user_id}`)
        .then((res) => {
          console.log('res', res);
          if (!res || res.error || res.message) {
            this.error_message = 'Failed to delete user';
            return;
          }
          this.success_message = 'User deleted successfully';
          window.setTimeout(this.redirectToUsers, 3000);
        })
        .catch((error) => {
          console.error('error', error);
          this.error_message = 'Failed to delete user';
        });
    },
    redirectToUsers() {
      console.log('redirectToUsers');
      window.location.href = `${window.location.origin}/users`;
    }
  }
};
</script>

<style lang="scss">
.button-container {
  display: flex;
  justify-content: space-between;
}

.delete-btn:hover {
  cursor: pointer;
}

.delete-user {
  &__line {
    display: flex;
  }

  .error {
    margin-top: 20px;
    color: red;
  }

  .success {
    margin-top: 20px;
    color: green;
  }
}
</style>
